export const propPoliciesRoomsHc = {
  policies: {
    breadcrumb: `Informativa sulla privacy`,
    cloneTitleNoun: `politiche dell'alloggio`,
    cloneItemNoun: `le politiche`,
    editorHintLang: `Informativa sulla privacy in {label}`,
    optional: `(facoltativo)`,
    headingOpt1: `Titolo 1`,
    headingOpt2: `Titolo 2`,
    headingOpt3: `Titolo 3`,
    headingNormal: `Normale`,
    tipBold: `Grassetto`,
    tipItalic: `Corsivo`,
    tipUnderline: `Sottolineato`,
    tipListOrdered: `Elenco ordinato`,
    tipListBullet: `Elenco puntato`,
    tipLink: `Collegamento`,
    tipQuote: `Citazione`,
    tipClean: `Cancella formattazione`,
    charCount: `{count} carattere | {count} caratteri`,
    saving: `Salvataggio…`,
    editorPlaceholder: `Scrivi qui l'informativa sulla privacy in {label}…`,
    errNoListing: `Annuncio non trovato.`,
    errLoad: `Impossibile caricare l'informativa sulla privacy.`,
    errEsRequired: `L'informativa in spagnolo è obbligatoria.`,
    saveSuccess: `Informativa sulla privacy salvata correttamente.`,
    saveError: `Errore durante il salvataggio delle politiche.`,
  },
  rooms: {
    bulkTitle: `Crea camere in blocco`,
    bulkSubtitle: `Genera più camere per un tipo, con codice automatico e descrizione facoltativa.`,
    available: `Disponibili: {count}`,
    willCreate: `Verranno create: {count}`,
    needTypeFirst: `Crea prima almeno un <b>Tipo di camera</b> per poter generare le camere.`,
    labelType: `Tipo`,
    selectType: `Seleziona un tipo`,
    labelQuantity: `Quantità`,
    phQuantity: `Es.: 10`,
    labelPrefix: `Prefisso codice`,
    phPrefix: `Es.: A- o 10`,
    optional: `Facoltativo`,
    labelStart: `Inizio`,
    labelPadding: `Padding`,
    labelDescription: `Descrizione (facoltativo)`,
    phDescription: `Verrà applicata alle camere create`,
    nameEqType: `Nome = Tipo`,
    recommended: `(consigliato)`,
    example: `Esempio:`,
    createBulk: `Crea in blocco`,
    typeFallback: `Tipo`,
    previewFormat: `{name} • Codice: {code}`,
    noActivePlan: `Non hai un piano attivo per creare camere.`,
    limitReached: `Limite raggiunto: il tuo piano consente {limit} camere per questa proprietà.`,
    selectTypeWarn: `Seleziona un tipo di camera.`,
    invalidQuantity: `Indica una quantità valida.`,
    cannotAddMore: `Non puoi aggiungerne altre. Limite: {limit}.`,
    partialCreated: `Ne sono state create solo {created} perché il tuo piano ne consente {limit} e te ne restavano {remaining}.`,
    planLimitSave: `Il tuo piano consente {limit} camere. Stai provando a salvarne {count}.`,
  },
  images: {
    zipDownloadTitle: `Scarica tutte le immagini della proprietà in un file ZIP`,
    zipNoImages: `Nessuna immagine da scaricare`,
    preparing: `Preparazione…`,
    downloadImages: `Scarica immagini`,
    loading: `Caricamento immagini…`,
    noAccommodations: `Nessun alloggio ancora configurato per questa proprietà.`,
    engineCoverTag: `Copertina del motore`,
    imageCount: `{count} immagine | {count} immagini`,
    hotelPhotosDesc: `Foto generali (cortile, ingresso, reception…) che il cliente vedrà aprendo il motore`,
    dragToOrder: `Trascina per ordinare la galleria`,
    ordering: `Ordinamento…`,
    dragTip: `Trascina`,
    hotelSectionName: `Foto dell'hotel · aree comuni`,
    orderUpdated: `Ordine delle immagini aggiornato.`,
    orderError: `Impossibile aggiornare l'ordine delle immagini.`,
    downloadError: `Impossibile scaricare le immagini.`,
  },
};
